import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = []

const fetchActions = generateActions('lots/categories/FETCH')

export const getCategories = createAction(
  API_CONST, 
  (type = 'lots', params = {}) => ({
  actions: fetchActions,
  url: `${type}/categories`,
  params: { ...params}
}),
  (type, params = {}) => ({ type })
)

export default handleActions({
  [fetchActions[0]]: () => ([ ...initial ]),
  [fetchActions[1]]: (state, { payload }) => ([ ...payload ])
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/categories/index.js